import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetSaleTemplatesBestOffersQueryResponse, GetSaleTemplatesBestOffersQueryParams, GetSaleTemplatesBestOffers400, GetSaleTemplatesBestOffers404, GetSaleTemplatesBestOffers500 } from "../types/GetSaleTemplatesBestOffers";

export const getSaleTemplatesBestOffersQueryKey = (params?: GetSaleTemplatesBestOffersQueryParams) =>     [{url:`/api/requests/list/templates/bestoffers`},...(params ? [params] : [])] as const;
      export function getSaleTemplatesBestOffersQueryOptions <TData = GetSaleTemplatesBestOffersQueryResponse, TError = GetSaleTemplatesBestOffers400 | GetSaleTemplatesBestOffers404 | GetSaleTemplatesBestOffers500>(params?: GetSaleTemplatesBestOffersQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getSaleTemplatesBestOffersQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/requests/list/templates/bestoffers`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получение списка лучших предложений на главной странице
 * @link /api/requests/list/templates/bestoffers
 */

export function useGetSaleTemplatesBestOffers <TData = GetSaleTemplatesBestOffersQueryResponse, TError = GetSaleTemplatesBestOffers400 | GetSaleTemplatesBestOffers404 | GetSaleTemplatesBestOffers500>(params?: GetSaleTemplatesBestOffersQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSaleTemplatesBestOffersQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getSaleTemplatesBestOffersQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
